export const API_URL = 'aiLayers'
export const ROUTE_NAME = 'aiLayers'
